/*
 * Copyright (C) 2018 Bruno López Trigo
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
    TextField,
    FormControlLabel,
    Checkbox,
    Tooltip,
    Paper,
    Typography,
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    Input,
    MenuItem
} from "@material-ui/core";
import {
    uploadDataset,
    buildClassifier,
    buildRules,
    deleteDataset, buildTree, buildFingrams
} from "../global/API";
import CustomizedSnackbars from "../global/CustomizedSnackbars";
import { Redirect } from "react-router-dom";

const styles = theme => ({
    root: {
        color: "#4caf50",
        "&$checked": {
            color: "#4caf50"
        }
    },
    checked: {},
    container: {
        marginBottom:100,
        paddingTop: 100,
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
        margin: "auto",
        width: "90%",
        textAlign: "center"
    },
    textField: {
        width: "100%"
    },
    textFieldName: {
        width: "100%",
        marginTop: 20
    },
    booleanBar: {
        display: "-webkit-flex",
        webkitFlexWrap: "wrap",
        flexWrap: "wrap",
        justifyContent: "space-around"
    },
    button: {
        width:"150px",
        marginTop: "30px",
        backgroundColor: "#4caf50",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#357a38"
        }
    },
    buttonCancel: {
        width:"150px",
        marginTop: "30px",
        backgroundColor: "#ff5f52",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#C62828"
        }
    },
    icon: {
        marginLeft: 10
    },
    file: {
        marginTop: 20
    },
    progress: {
        margin: "auto",
        marginTop: 80,
        marginBottom: 30
    },
    loader: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        justifyItems: "center"
    },
    formControl: {
        width: "100%",
        textAlign: "left"
    }
});

class FormConfigurationHTFuzzy extends Component {
    constructor(props) {
        console.log("Hola")
        super(props);
        this.state = {
            algorithm: "FuzzyHoeffdingDecisionTree",
            HTparams: {
                fuzzyCardinality: true,
                fuzzySets: 3,
                propertyLabels:"L1,L2,L3",
                centroids: "0.5",
                gracePeriod: 25.0,
                hoeffdingTieThreshold: 2.5,
                leafPredictionStrategy:0,
                minimumFractionOfWeightInfoGain: 0.01,
                naiveBayesPredictionThreshold: 0.0,
                numDecimalPlaces: 2,
                printLeafModels: false,
                admitRepetitions:false,
                splitConfidence: 1.0e-7,
                splitCriterion:1
            }
        };
        this.buildClassifier = this.buildClassifier.bind(this);
        this.changeFile = this.changeFile.bind(this);
        this.saveConfiguration = this.saveConfiguration.bind(this);
        this.cancelOperation = this.cancelOperation.bind(this);
    }
    async saveConfiguration() {
        if (
            !this.state.fuzzyCardinality &&
            !this.state.fuzzySets &&
            !this.state.propertyLabels &&
            !this.state.centroids &&
            !this.state.gracePeriod &&
            !this.state.hoeffdingTieThreshold &&
            !this.state.leafPredictionStrategy &&
            !this.state.minimumFractionOfWeightInfoGain &&
            !this.state.naiveBayesPredictionThreshold &&
            !this.state.numDecimalPlaces &&
            !this.state.printLeafModels &&
            !this.state.admitRepetitions  &&
            !this.state.splitConfidence &&
            !this.state.splitCriterion ) {
            this.props.saveConfigurationHTFuzzy(this.state.HTparams);
        }else{

            this.setState({
                error:true,
                message:"You can´t save this configuration. You have an error in one parameter"
            })
        }
    }
    async cancelOperation() {
        this.props.exitConfigurationHtFuzzy();
    }
    handleClose = (event, reason) => {
        this.setState({
            error: false
        });
    };

    handleChange = name => event => {
        var regex = /^[A-Za-z0-9]{4,20}$/;
        this.setState({
            nameError: event.target.value.match(regex) ? false : true,
            [name]: event.target.value
        });
    };

    handleChangeSelect = name => event => {
        var params = this.state.HTparams;
        params[name] = event.target.value;
        this.setState({
            HTparams: params
        });
    };

    handleChangeParam = name => event => {
        var regex = /^-?[0-9]+\.?[0-9]*$/;
        var params = this.state.HTparams;
        params[name] = event.target.value;
        this.setState({
            HTparams: params,
            [name]: event.target.value.match(regex) ? false : true
        });
    };

    handleChangeParamArray = name => event => {
        let valueArray;
        let array;
        let labels;
        var regex = /^(-?[0-9]+\.?[0-9]*,)*?[0-9]*\.?[0-9]*$/;
        var params = this.state.HTparams;
        params[name] = event.target.value;
        debugger
        if(name==="fuzzySets") {
            var value = event.target.value;
            if (value.includes(",")) {
                var arrayTmp = "";
                labels = "";
                array = value.split(",");
                for (var i = 0; i < array.length; i++) {
                    valueArray = 1 / (array[i] - 1);
                    labels +="L1,";
                    for (var j = 0; j < (array[i] - 2); j++) {
                        labels+= "L"+(j+2)+",";
                        if (i === 0 && j === 0) {
                            arrayTmp += valueArray;
                        } else {
                            arrayTmp += "," + (valueArray*(j+1)).toFixed(2);
                        }
                    }
                    if(i===array.length-1) {
                        labels += "L" + array[i] ;
                    }else{
                        labels += "L" + array[i]+",";
                    }
                }
                params["centroids"] = arrayTmp;
                params["propertyLabels"] = labels;
                this.setState({
                    HTparams: params,
                    [name]: event.target.value.match(regex) ? false : true
                });
            } else if (value <= 2) {
                if(value === 2) {
                    params["propertyLabels"] = "L1,L2";
                } else {
                    params["propertyLabels"] = "L1";
                }
                this.setState({
                    HTparams: params,
                    [name]: event.target.value.match(regex) ? false : true
                });
            } else {
                valueArray = 1 / (value - 1);
                array = valueArray.toFixed(2);
                labels = "L1,L2,";
                for ( i = 0; i < (value - 3); i++) {
                    labels += "L"+(i+3)+",";
                    array += "," + (valueArray*(i+2)).toFixed(2);
                }
                labels += "L"+(value);
                params["centroids"] = array;
                params["propertyLabels"]= labels;
                this.setState({
                    HTparams: params,
                    [name]: event.target.value.match(regex) ? false : true
                });
            }
        }else{
            this.setState({
                HTparams: params,
                [name]: event.target.value.match(regex) ? false : true
            });
        }
    };

    handleChangeParamArrayString = name => event => {
        var regex = /^(-?[A-ZÑa-zñ0-9-_]+\.?[0-9]*,)*?[A-ZÑa-zñ0-9-_]*\.?[0-9]*$/;
        var params = this.state.HTparams;
        params[name] = event.target.value;
        this.setState({
            HTparams: params,
            [name]: event.target.value.match(regex) ? false : true
        });
    };

    handleChangeParamExponencial = name => event => {
        var regex = /^-?[0-9]+\.?[0-9]*(e|E)(\+|-)[0-9]+$/;
        var params = this.state.HTparams;
        params[name] = event.target.value;
        this.setState({
            HTparams: params,
            [name]: event.target.value.match(regex) ? false : true
        });
    };

    handleChangeBoolean = name => event => {
        var params = this.state.HTparams;
        params[name] = event.target.checked;
        this.setState({ HTparams: params });
    };

    changeFile(event) {
        this.setState({
            file: event.target.files[0]
        });
    }

    async buildClassifier() {
        console.log(this.state)
        if (
            !this.state.batchSize &&
            !this.state.folds &&
            !this.state.minNo &&
            !this.state.numDecimalPlaces &&
            !this.state.optimizations &&
            !this.state.seed &&
            !this.state.uncovAction &&
            this.state.file
        ) {
            this.setState({
                loading: true
            });
            var response = await uploadDataset(
                this.state.name,
                this.state.file,
                this.props.token
            );
            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        loading: false,
                        redirect: true
                    });
                } else {
                    this.setState({
                        loading: false,
                        error: true,
                        message: response.data
                    });
                }
            } else {
                this.setState(
                    {
                        dataset: response.data
                    },
                    async () => {
                        response = await buildClassifier(
                            this.state.name,
                            this.state.HTparams,
                            this.state.algorithm,
                            this.props.token
                        );
                        if (response.error) {
                            if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                    loading: false,
                                    redirect: true
                                });
                            } else {
                                await deleteDataset(this.state.name, this.props.token);
                                this.setState({
                                    loading: false,
                                    error: true,
                                    message: response.data
                                });
                            }
                        } else {
                            this.setState(
                                {
                                    classifier: response.data
                                },
                                async () => {
                                    response = await buildTree(
                                        this.state.name,
                                        this.state.algorithm,
                                        this.props.token
                                    );
                                    if (response.error) {
                                        if (response.status === 401) {
                                            this.props.handleGlobalMessage(
                                                "error",
                                                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                            );
                                            this.props.closeSession();
                                            this.setState({
                                                loading: false,
                                                redirect: true
                                            });
                                        } else {
                                            await deleteDataset(this.state.name, this.props.token);
                                            this.setState({
                                                loading: false,
                                                error: true,
                                                message: response.data
                                            });
                                        }
                                    } else {
                                        this.setState(
                                            async () => {
                                                response = await buildRules(
                                                    this.state.name,
                                                    this.state.algorithm,
                                                    this.props.token
                                                );
                                                if (response.error) {
                                                    if (response.status === 401) {
                                                        this.props.handleGlobalMessage(
                                                            "error",
                                                            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                                        );
                                                        this.props.closeSession();
                                                        this.setState({
                                                            loading: false,
                                                            redirect: true
                                                        });
                                                    } else {
                                                        await deleteDataset(this.state.name, this.props.token);
                                                        this.setState({
                                                            loading: false,
                                                            error: true,
                                                            message: response.data
                                                        });
                                                    }
                                                } else {
                                                    this.setState({
                                                    },async () => {
                                                        response = await buildFingrams(
                                                            this.state.name,
                                                            this.state.algorithm,
                                                            this.props.token,
                                                            this.props.language.id,
                                                        );
                                                        if (response.error) {
                                                            if (response.status === 401) {
                                                                this.props.handleGlobalMessage(
                                                                    "error",
                                                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                                                );
                                                                this.props.closeSession();
                                                                this.setState({
                                                                    loading: false,
                                                                    redirect: true
                                                                });
                                                            } else {
                                                                this.setState({
                                                                    loading: false,
                                                                    error: true,
                                                                    message: response.data
                                                                });
                                                            }
                                                        } else {
                                                            this.props.handleGlobalMessage(
                                                                "success",
                                                                "Dataset " + this.state.name + this.props.language.labels[this.props.language.id].succesfullyCreated
                                                            );
                                                            this.setState(
                                                                {
                                                                    loading: false,
                                                                    ready: true
                                                                });
                                                        }
                                                    });
                                                }
                                            }
                                        );
                                    }
                                }
                            );
                        }
                    }
                );
            }
        } else if (this.props.classifierExists &&
            !this.state.batchSize &&
            !this.state.folds &&
            !this.state.minNo &&
            !this.state.numDecimalPlaces &&
            !this.state.optimizations &&
            !this.state.seed &&
            !this.state.uncovAction
        ) {
            this.setState({
                loading: true
            });
            response = await buildClassifier(
                this.props.dataset,
                this.state.HTparams,
                this.state.algorithm,
                this.props.token
            );
            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        loading: false,
                        redirect: true
                    });
                } else {
                    this.setState({
                        loading: false,
                        error: true,
                        message: response.data
                    });
                }
            } else {
                this.setState(
                    {
                        classifier: response.data
                    },
                    async () => {
                        response = await buildTree(
                            this.props.dataset,
                            this.state.algorithm,
                            this.props.token
                        );
                        if (response.error) {
                            if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                    loading: false,
                                    redirect: true
                                });
                            } else {
                                this.setState({
                                    loading: false,
                                    error: true,
                                    message: response.data
                                });
                            }
                        } else {
                            this.setState({
                                    loading: false,
                                },
                                async () => {
                                    response = await buildRules(
                                        this.state.name,
                                        this.state.algorithm,
                                        this.props.token
                                    );
                                    if (response.error) {
                                        if (response.status === 401) {
                                            this.props.handleGlobalMessage(
                                                "error",
                                                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                            );
                                            this.props.closeSession();
                                            this.setState({
                                                loading: false,
                                                redirect: true
                                            });
                                        } else {
                                            await deleteDataset(this.state.name, this.props.token);
                                            this.setState({
                                                loading: false,
                                                error: true,
                                                message: response.data
                                            });
                                        }
                                    } else {
                                        this.props.handleGlobalMessage(
                                            "success",
                                            "Dataset " + this.state.name +this.props.language.labels[this.props.language.id].succesfullyCreated
                                        );
                                        this.setState({
                                                loading: false,
                                            },async () => {
                                                response = await buildFingrams(
                                                    this.state.name,
                                                    this.state.algorithm,
                                                    this.props.token,
                                                    this.props.language.id,
                                                );
                                                if (response.error) {
                                                    if (response.status === 401) {
                                                        this.props.handleGlobalMessage(
                                                            "error",
                                                            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                                        );
                                                        this.props.closeSession();
                                                        this.setState({
                                                            loading: false,
                                                            redirect: true
                                                        });
                                                    } else {
                                                        this.setState({
                                                            loading: false,
                                                            error: true,
                                                            message: response.data
                                                        });
                                                    }
                                                } else {
                                                    this.props.handleGlobalMessage(
                                                        "success",
                                                        "Dataset " + this.state.name + this.props.language.labels[this.props.language.id].succesfullyCreated
                                                    );
                                                    this.setState({
                                                        loading: false,
                                                        ready: true
                                                    });
                                                }
                                            }
                                        );
                                    }
                                }
                            );
                        }
                    }
                );
            }
        } else if (!this.state.file) {
            this.setState({
                error: true,
                message: "Please upload the dataset file"
            });
        } else {
            this.setState({
                error: true,
                message: "Wrong params, please check fields"
            });
        }
    }

    async componentDidMount() {}

    render() {
        const { classes } = this.props;

        return this.state.loading ? (
            <div className={classes.loader}>
                <CircularProgress className={classes.progress} size={100} />
                <Typography variant="h3" align="center">
                    {this.props.language.labels[this.props.language.id].loading}
                </Typography>
            </div>
        ) : (
            <Fragment>
                <Paper  className={classes.container}>
                    <Typography variant="h4">
                        {this.props.language.labels[this.props.language.id].build +
                        " " +
                        this.state.algorithm}
                    </Typography>
                    <form>
                        <Tooltip
                            title="Choose the number of fuzzy sets by which the data set is divided."
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="fuzzySets"
                                className={classes.textField}
                                value={this.state.HTparams.fuzzySets}
                                onChange={this.handleChangeParamArray("fuzzySets")}
                                margin="normal"
                                error={this.state.fuzzySets}
                            />
                        </Tooltip>
                        <Tooltip
                            title="Choose the names of the labels of properties(this field may be empty)."
                            placement="top"
                        >
                            <TextField
                                id="propertyLabels"
                                label="Property labels"
                                className={classes.textField}
                                value={this.state.HTparams.propertyLabels}
                                onChange={this.handleChangeParamArrayString("propertyLabels")}
                                margin="normal"
                                error={this.state.propertyLabels}
                            />
                        </Tooltip>
                        <Tooltip
                            title="Choose the position of centroids. The number of centroids have to be equal N-2 beeing N the number of sets"
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="Centroids"
                                className={classes.textField}
                                value={this.state.HTparams.centroids}
                                onChange={this.handleChangeParamArray("centroids")}
                                margin="normal"
                                error={this.state.centroids}
                            />
                        </Tooltip>
                        <Tooltip
                            title="Number of instances (or total weight of instances) a leaf should observe between split attempts."
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="gracePeriod"
                                className={classes.textField}
                                value={this.state.HTparams.gracePeriod}
                                onChange={this.handleChangeParam("gracePeriod")}
                                margin="normal"
                                error={this.state.gracePeriod}
                            />
                        </Tooltip>
                        <Tooltip
                            title="Threshold below which a split will be forced to break ties."
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="hoeffdingTieThreshold"
                                className={classes.textField}
                                value={this.state.HTparams.hoeffdingTieThreshold}
                                onChange={this.handleChangeParam("hoeffdingTieThreshold")}
                                margin="normal"
                                error={this.state.hoeffdingTieThreshold}
                            />
                        </Tooltip>

                        <Tooltip
                            title="The leaf prediction strategy to use"
                            placement="top"
                        >
                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="leafPredictionStrategy">Leaf Prediction Strategy</InputLabel>
                                <Select
                                    value={this.state.HTparams.leafPredictionStrategy}
                                    onChange={this.handleChangeSelect("leafPredictionStrategy")}
                                    input={<Input name="leafPredictionStrategy" id="leafPredictionStrategy" />}
                                >
                                    <MenuItem value={0}>Majority class</MenuItem>
                                    <MenuItem value={1}>Naive Bayes</MenuItem>
                                    <MenuItem value={2}>Naive Bayes adaptive</MenuItem>
                                </Select>
                            </FormControl>
                        </Tooltip>
                        <Tooltip title="Minimum fraction of weight required down at least two branches for info gain splitting." placement="top">
                            <TextField
                                id="standard-name"
                                label="minimumFractionOfWeightInfoGain"
                                className={classes.textField}
                                value={this.state.HTparams.minimumFractionOfWeightInfoGain}
                                onChange={this.handleChangeParam("minimumFractionOfWeightInfoGain")}
                                margin="normal"
                                error={this.state.minimumFractionOfWeightInfoGain}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The number of instances (weight) a leaf should observe before allowing naive Bayes (adaptive) to make predictions
"
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="naiveBayesPredictionThreshold"
                                className={classes.textField}
                                value={this.state.HTparams.naiveBayesPredictionThreshold}
                                onChange={this.handleChangeParam("naiveBayesPredictionThreshold")}
                                margin="normal"
                                error={this.state.naiveBayesPredictionThreshold}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The allowable error in a split decision. Values closer to zero will take longer to decide."
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="splitConfidence"
                                className={classes.textField}
                                value={this.state.HTparams.splitConfidence}
                                onChange={this.handleChangeParamExponencial("splitConfidence")}
                                margin="normal"
                                error={this.state.splitConfidence}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The number of decimal places to be used for the output of numbers in the model."
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="numDecimalPlaces"
                                className={classes.textField}
                                value={this.state.HTparams.numDecimalPlaces}
                                onChange={this.handleChangeParam("numDecimalPlaces")}
                                margin="normal"
                                error={this.state.numDecimalPlaces}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The splitting criterion to use"
                            placement="top"
                        >
                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="splitCriterion">Split Criterion</InputLabel>
                                <Select
                                    value={this.state.HTparams.splitCriterion}
                                    onChange={this.handleChangeSelect("splitCriterion")}
                                    input={<Input name="splitCriterion" id="splitCriterion" />}
                                >
                                    <MenuItem value={0}>
                                        Gini split
                                    </MenuItem>
                                    <MenuItem value={1}>
                                        Info gain split
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Tooltip>
                        <div className={classes.booleanBar}>
                            <Tooltip
                                title="Print leaf models (naive bayes leaves only)"
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.HTparams.printLeafModels}
                                            onChange={this.handleChangeBoolean("printLeafModels")}
                                            value="printLeafModels"
                                            color="primary"
                                        />
                                    }
                                    label="printLeafModels"
                                />
                            </Tooltip>
                            <Tooltip
                                title="Admit repetitions"
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.HTparams.admitRepetitions}
                                            onChange={this.handleChangeBoolean("admitRepetitions")}
                                            value="admitRepetitions"
                                            color="primary"
                                        />
                                    }
                                    label="admitRepetitions"
                                />
                            </Tooltip>
                            <Tooltip
                                title="Fuzzy cardinality to use "
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.HTparams.fuzzyCardinality}
                                            onChange={this.handleChangeBoolean(
                                                "fuzzyCardinality"
                                            )}
                                            value="fuzzyCardinality"
                                            color="primary"
                                        />
                                    }
                                    label="fuzzyCardinality"
                                />
                            </Tooltip>
                        </div>

                        <Button
                            variant="contained"
                            className={classes.button}
                            onClick={this.saveConfiguration}
                        >
                            {this.props.language.labels[this.props.language.id].saveButton}
                        </Button>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        <Button
                            variant="contained"
                            className={classes.buttonCancel}
                            onClick={this.cancelOperation}
                        >
                            {this.props.language.labels[this.props.language.id].cancelButton}
                        </Button>

                    </form>
                </Paper>
                <CustomizedSnackbars
                    openFail={this.state.error}
                    handleClose={this.handleClose}
                    message={this.state.message}
                />
                {this.state.redirect && <Redirect to="/" />}
                {this.state.ready && <Redirect to="/datasets" />}
            </Fragment>
        );
    }
}

FormConfigurationHTFuzzy.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(FormConfigurationHTFuzzy);
